import React from "react";
import Typical from "react-typical";
import "./Text.css";
function Text() {
  return (
    <div className="text-wrapper reset-this-root">
      <Typical
        steps={[
          "Web Developer",
          1000,
          "Web Designer",
          1000,
          "Full Stack Web Developer",
          1000,
        ]}
        loop={Infinity}
        wrapper="b"
      />
    </div>
  );
}

export default Text;
